export const validateEmail = (email: string): boolean => {
    const patternToMatch =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return patternToMatch.test(String(email).toLowerCase());
};

export const validatePhone = (phone: string): boolean => {
    // This regex allows:
    //
    // 1. 10-digit US phone numbers (which can't start with a 1),
    //    with an optional +1 in the front.
    // 2. International phone numbers, which have a 1–3 digit country code
    //    (which can't start with a 1, as that's reserved for North America),
    //    followed by a 5–12 digit subscriber phone number.
    //
    // No other phone characters like hyphens, parentheses, or periods are allowed.
    //
    // This roughly aligns with the E.164 format we store phone numbers in
    //  and that everyone including Twilio expects.
    //
    const patternToMatch = /^(?:\+1)?[2-9]\d{9}$|^\+[2-9]\d{0,2}\d{5,12}$/;
    return patternToMatch.test(phone);
};

// Accepts exactly a 5-digit US zip code, matching the backend's ZipCode scalar.
export const validateZipcode = (zipcode: string): boolean => /^\d{5}$/.test(zipcode);
